// extracted by mini-css-extract-plugin
export default {"container":"dropdown-option_container__Lo0wQ","label":"dropdown-option_label__p-I-A","center":"dropdown-option_center__dkJkt","count":"dropdown-option_count__OoRo0"};